"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipeGeneratorV4 = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const PointLocation_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocation.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const mainPipeLinker_1 = require("./mainPipeLinker");
const pipeGenerator_normalRoom_1 = require("./pipeGenerator_normalRoom");
const pipeGenerator_warehouse_V2_1 = require("./pipeGenerator_warehouse_V2");
const testUtil_1 = require("./util/testUtil");
const mainDirectionUtil_1 = require("./util/mainDirectionUtil");
const mainPipeLinker_warehouse_b_1 = require("./mainPipeLinker_warehouse_b");
const attachDistance = 100; //和闭合区域提取那边的是同一个值
class PipeGeneratorV4 {
    constructor(sprayRadius, minDisToWall, minDisBetweenSprinklers) {
        this._roomPipeInfos = [];
        this._radius = sprayRadius;
        this._blankDis = this._radius / Math.SQRT2;
        this._minDisToWall = minDisToWall;
        this._minDisBetweenSprinklers = minDisBetweenSprinklers;
        console.log("blankDis:", this._blankDis);
    }
    generate(polygons, mainPipes, mainPipeNodes, geometryParser) {
        let originMainPipes = mainPipes.concat();
        //区分房间和走廊
        let sortResult = this.sortOutRoomType(polygons, originMainPipes);
        //根据与绘制的主管线的距离，对房间进行从远到近排序
        this.sortRoomsByDistanceToMainPipes(sortResult.normalRoomArr, originMainPipes);
        let results = new Array();
        let mainPipesLink = new Array();
        //mainPipes是绘制的主管线调整后的线段数组
        //mainPipesLink是新增的连接到mainPipes的线段数组
        //先生成普通房间的
        for (let polygon of sortResult.normalRoomArr) {
            let result = this.singleGenerate(polygon, mainPipes, mainPipesLink, mainPipeNodes, geometryParser, originMainPipes, false);
            if (result)
                results.push(result);
        }
        //再生成走廊的
        for (let polygon of sortResult.warehouseAndHallWayArr) {
            let result = this.singleGenerate(polygon, mainPipes, mainPipesLink, mainPipeNodes, geometryParser, originMainPipes, true);
            if (result)
                results.push(result);
        }
        return results;
    }
    sortOutRoomType(polygons, originMainPipes) {
        let warehouseAndHallWayArr = [];
        let normalRoomArr = [];
        for (let polygon of polygons) {
            const shell = polygon.getExteriorRing();
            let points_shell = shell.getCoordinates();
            //目前不考虑主管道横穿整个房间的情况
            let isWarehouseAndHallWay = false;
            for (let mainPipe of originMainPipes) {
                let inPolygon_p0 = PointLocation_js_1.default.isInRing(mainPipe.p0, points_shell);
                let inPolygon_p1 = PointLocation_js_1.default.isInRing(mainPipe.p1, points_shell);
                if (inPolygon_p0 || inPolygon_p1) {
                    isWarehouseAndHallWay = true;
                    break;
                }
            }
            if (isWarehouseAndHallWay) {
                warehouseAndHallWayArr.push(polygon);
            }
            else {
                normalRoomArr.push(polygon);
            }
        }
        return {
            warehouseAndHallWayArr: warehouseAndHallWayArr,
            normalRoomArr: normalRoomArr,
        };
    }
    sortRoomsByDistanceToMainPipes(polygons, mainPipes) {
        let minDistanceMap = new Map();
        for (let polygon of polygons) {
            let center = polygon.getEnvelopeInternal().centre();
            let minDis = Number.POSITIVE_INFINITY;
            for (let pipe of mainPipes) {
                let dis = pipe.distance(center);
                minDis = Math.min(minDis, dis);
            }
            minDistanceMap.set(polygon, minDis);
        }
        polygons.sort((a, b) => minDistanceMap.get(a) - minDistanceMap.get(b));
    }
    singleGenerate(polygon, mainPipes, mainPipesLink, mainPipeNodes, geometryParser, originMainPipes, isWarehouseAndHallWay) {
        let polygonSegs_shell = new Array();
        let polygonSegs_holes = new Array();
        let polygonSegs_shellAndLargeHoles = new Array();
        const shell = polygon.getExteriorRing();
        let points_shell = shell.getCoordinates();
        for (let i = 0; i < points_shell.length - 1; i++) {
            let seg = new LineSegment_js_1.default(points_shell[i], points_shell[i + 1]);
            polygonSegs_shell.push(seg);
            if (isWarehouseAndHallWay) {
                polygonSegs_shellAndLargeHoles.push(seg);
            }
        }
        for (let i = 0; i < polygon.getNumInteriorRing(); i++) {
            const hole = polygon.getInteriorRingN(i);
            let points_hole = hole.getCoordinates();
            //排除柱子之类的孔洞
            let isLargeHole = isWarehouseAndHallWay && new GeometryFactory_js_1.default().createPolygon(hole).getArea() > 1000000;
            for (let i = 0; i < points_hole.length - 1; i++) {
                let seg = new LineSegment_js_1.default(points_hole[i], points_hole[i + 1]);
                polygonSegs_holes.push(seg);
                if (isLargeHole) {
                    polygonSegs_shellAndLargeHoles.push(seg);
                }
            }
        }
        let polygonSegs_total = polygonSegs_shell.concat(polygonSegs_holes);
        //三种情况：
        //1.主管道不在多边形内，有门——普通房间
        //2.主管道不在多边形内，无门——异常情况，跳过
        //3.主管道在多边形内——走廊或仓库
        //计算属于多边形的门
        let doors_belongHere = this.computeDoorsBelongThisRoom(polygonSegs_shell, geometryParser); //TODO：这里不能只用外壳，不然会漏掉某些情况
        if (!doors_belongHere) {
            return null;
        }
        //正常房间里是不会有绘制的主管道的，所以通过有无主管道来判断是走廊和仓库，还是普通房间
        let pipeResult = null;
        if (isWarehouseAndHallWay) { //以下是走廊和仓库的情况
            let mainPipesInRoom = new Array();
            for (let mainPipe of mainPipes.concat(mainPipesLink)) {
                let inPolygon_p0 = PointLocation_js_1.default.isInRing(mainPipe.p0, points_shell);
                let inPolygon_p1 = PointLocation_js_1.default.isInRing(mainPipe.p1, points_shell);
                if (inPolygon_p0 || inPolygon_p1) {
                    mainPipesInRoom.push(mainPipe);
                }
            }
            let directionResult = new mainDirectionUtil_1.MainDirectionUtil().compute(points_shell, doors_belongHere, mainPipesInRoom, polygonSegs_total);
            testUtil_1.TestUtil.coordinateUtil = directionResult.coordinateUtil;
            pipeResult = new pipeGenerator_warehouse_V2_1.PipeGenerator_warehouseAndHallWay_V2().generate(points_shell, this._blankDis, this._minDisToWall, this._minDisBetweenSprinklers, mainPipesInRoom, polygonSegs_total, polygon, directionResult.coordinateUtil);
            if (pipeResult) {
                new mainPipeLinker_warehouse_b_1.MainPipeLinker_Warehouse_b(directionResult.coordinateUtil, polygonSegs_total, polygonSegs_shellAndLargeHoles, mainPipes, mainPipesInRoom, mainPipeNodes).linkV3(pipeResult._pipeNodeGroups, mainPipes, mainPipesInRoom, this._blankDis, originMainPipes);
                //new MainPipeLinker_Warehouse(directionResult.coordinateUtil, polygonSegs_total).linkV3(pipeResult._pipeNodeGroups, mainPipeNodes, mainPipesInRoom, this._blankDis, originMainPipes);
            }
        }
        else { //以下是普通房间的情况
            //pipeResult = new PipeGenerator_normalRoom().generate(points_shell, doors_belongHere, this._blankDis, this._minDisToWall, mainPipes, polygonSegs_total, polygon);
            pipeResult = new pipeGenerator_normalRoom_1.PipeGenerator_normalRoom().generate_V2(points_shell, doors_belongHere, this._radius, this._minDisToWall, mainPipes, polygonSegs_total, polygon);
            if (pipeResult) {
                let roomPipeInfos = new mainPipeLinker_1.MainPipeLinker().linkForNormalRoom(pipeResult._pipeNodeGroups, mainPipes, mainPipesLink, mainPipeNodes, this._roomPipeInfos, polygon);
                this._roomPipeInfos = this._roomPipeInfos.concat(roomPipeInfos);
            }
        }
        if (pipeResult) {
            pipeResult._polygonPoints = points_shell;
            pipeResult._doors = doors_belongHere;
        }
        return pipeResult;
    }
    computeDoorsBelongThisRoom(polygonSegs, geometryParser) {
        let doors_belongHere = new Array();
        //判断门属于哪个多边形。这里暂时没有对门的归属做限制，某些异常情况可能会导致门属于多个多边形
        let doors = geometryParser.getDoorLineSegments();
        for (let door of doors) {
            let door_points = [door.p0, door.p1];
            for (let i = 1; i >= 0; i--) {
                let point = door_points[i];
                for (let seg of polygonSegs) {
                    if (seg.distance(point) < attachDistance + 50) { //加个容差，减少漏判的情况
                        door_points.splice(i, 1);
                        break;
                    }
                }
            }
            if (door_points.length === 0) {
                doors_belongHere.push(door);
            }
        }
        if (doors_belongHere.length === 0) {
            console.error("该房间没有门");
            return null;
        }
        return doors_belongHere;
    }
}
exports.PipeGeneratorV4 = PipeGeneratorV4;
